var { calculatePopoverPosition } = require("./_position-popover");
var { fetchProductData, getUniqueProductIds } = require("./_product-data");

async function init() {

    // Gathers product IDs from ALL hotspots (filters duplicates)
    const uniqueProdIds = getUniqueProductIds(".hotspot");

    // returns lookup Map to match productId to data 
    // let itemLookupMap = await fetchProductData(uniqueProdIds);
    const { lookup: itemLookupMap, emptyProductList: emptyProducts } = await fetchProductData(uniqueProdIds);
    console.log("&&&&&&&&",emptyProducts);

    // Now initialize each container
    const imageContainers = document.querySelectorAll('.image-container');

    imageContainers.forEach(container => {
        const hotspots = container.querySelectorAll('.hotspot');
        const popover = container.querySelector('.hotspot_popover');
        const counter = container.querySelector('.hotspot_counter');

        // Null checks - gracefully skips this container if missing critical elements
        if (!popover || !counter || hotspots.length === 0) return;

        const popoverBrandLine = popover.querySelector('.popover_brand_text');
        const popoverLink = popover.querySelector('.popover_link');
        const popoverItemDescription = popover.querySelector('.popover_item_description');

        if (!popoverBrandLine || !popoverLink || !popoverItemDescription) return;

        let hotspotsVisible = true;        // default: hotspots visible on initial load
        let popoverLocked = false;         // true if popover stays open (i.e. on click/touch)
        let activeHotspot = null;

        // Tap detection variables for scroll-safe touch/pen
        let pointerStartX = 0;
        let pointerStartY = 0;
        let pointerMoved = false;
        const TAP_THRESHOLD = 8; // px

        // Apply API data to this container's hotspots
        hotspots.forEach(hs => {
            const productId = parseInt(hs.dataset.name, 10);
            if (emptyProducts.includes(productId)) {
                hs.style.display = 'none';
                return;
            }
            const matchingData = itemLookupMap.get(productId);
            if (matchingData) {
                hs.dataset.brand = matchingData.brand;
                hs.dataset.url = matchingData.url;
                hs.dataset.detail = matchingData.detail;
            }
        });

        function toggleHotspots() {
            hotspotsVisible = !hotspotsVisible;

            hotspots.forEach(hotspot => {
                hotspot.style.display = hotspotsVisible ? 'block' : 'none';
            });

            if (!hotspotsVisible) {
                popover.style.display = 'none';
                counter.classList.add('hidden-state');
            } else {
                counter.classList.remove('hidden-state');
            }
        }

        // Toggle hotspots with counter
        counter.addEventListener('pointerdown', e => {
            e.stopPropagation();
            toggleHotspots();
        });

        // Toggle hotspots with image container
        container.addEventListener('pointerdown', e => {
            // Don't toggle if clicking on popover, hotspots, or counter
            if (popover.contains(e.target)) return;
            if (counter.contains(e.target)) return;
            if (Array.from(hotspots).some(hs => hs.contains(e.target))) return;

            e.stopPropagation();

            toggleHotspots();
        });

        // Popover hover handlers
        popover.addEventListener('pointerleave', function (e) {
            if (e.pointerType !== 'mouse') return;
            if (popoverLocked) return;

            // Don't hide if mouse is moving back to the active hotspot
            if (activeHotspot && activeHotspot.contains(e.relatedTarget)) return;

            deactivateHotspot(activeHotspot);
            activeHotspot = null;
        });


        // Handle tap/hover on each hotspot
        hotspots.forEach(hotspot => {

            // Scroll-safe tap detection
            hotspot.addEventListener('pointerdown', e => {
                e.stopPropagation();
                pointerStartX = e.clientX;
                pointerStartY = e.clientY;
                pointerMoved = false;

                if (e.pointerType === 'touch' || e.pointerType === 'pen') {
                    hotspot.setPointerCapture(e.pointerId);
                } else {
                    // mouse click locks the popover
                    popoverLocked = true;
                    activateHotspot(hotspot)
                }
            });

            hotspot.addEventListener('pointermove', e => {
                if (e.pointerType === 'touch' || e.pointerType === 'pen') {
                    if (
                        Math.abs(e.clientX - pointerStartX) > TAP_THRESHOLD ||
                        Math.abs(e.clientY - pointerStartY) > TAP_THRESHOLD
                    ) {
                        pointerMoved = true;
                    }
                }
            });

            hotspot.addEventListener('pointerup', e => {
                if (e.pointerType === 'touch' || e.pointerType === 'pen') {
                    console.log("&&&&&&&SSSSSSSS");
                    hotspot.releasePointerCapture(e.pointerId);
                    if (pointerMoved) return; // user was scrolling


                    if (hotspot === activeHotspot) {
                        popoverLocked = false;
                        deactivateHotspot(hotspot);
                        activeHotspot = null;
                    } else {
            // 🔹 remove active class from all
            hotspots.forEach(hs => hs.classList.remove('active'));

            // 🔹 add active class to this one
            hotspot.classList.add('active');

                        popoverLocked = true;
                        activateHotspot(hotspot);
                    }

                }
            });

            // Hover preview for mouse only
            hotspot.addEventListener('pointerenter', e => {
                if (e.pointerType !== 'mouse') return;
                activateHotspot(hotspot);
            });

            hotspot.addEventListener('pointerleave', e => {
                if (e.pointerType !== 'mouse') return;
                if (popoverLocked) return;

                // Don't hide if mouse is moving to the popover
                if (popover.contains(e.relatedTarget)) return;

                deactivateHotspot(hotspot);
                activeHotspot = null;
            });

            // Keyboard support for accessibility
            hotspot.setAttribute('tabindex', '0');
            hotspot.setAttribute('role', 'button');
            hotspot.addEventListener('keydown', e => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    if (hotspot === activeHotspot) {
                        popoverLocked = false;
                        deactivateHotspot(hotspot);
                        activeHotspot = null;
                    } else {
                        popoverLocked = true;
                        activateHotspot(hotspot)
                    }
                }
            });
        });

        // Click outside to close popover (scoped per image)
        container.addEventListener('pointerdown', function (e) {
            if (popoverLocked &&
                !popover.contains(e.target) &&
                !(activeHotspot && activeHotspot.contains(e.target))) {

                popoverLocked = false;
                deactivateHotspot(activeHotspot);
                activeHotspot = null;
            }
        });

        // Functions to activate/deactivate hotspot
        function activateHotspot(hotspot) {
            // Deactivate previous hotspot if switching to a different one
            if (activeHotspot && activeHotspot !== hotspot) {
                deactivateHotspot(activeHotspot);
                popoverLocked = false; // Unlock when hovering to a new hotspot
            }
            const { x, y, brand, detail, url, name } = hotspot.dataset;


            const inner = hotspot.querySelector('.hs_inner');
            const outer = hotspot.querySelector('.hs_outer');

            calculatePopoverPosition(container, popover, x, y);


            popover.style.display = 'flex';
            popoverBrandLine.textContent = brand;
            popoverItemDescription.textContent = detail;
            
            // Generate LID from product ID (name)
            let finalUrl = `https://www.macys.com${url}`;
            if (name) {
                const lid = `prom_productgrid-${name}`;
                const separator = url.includes('?') ? '&' : '?';
                finalUrl = `${finalUrl}${separator}lid=${lid}`;
            }
            popoverLink.href = finalUrl;

            inner.setAttribute('r', '6');
            outer.setAttribute('fill-opacity', '0.40');

            activeHotspot = hotspot;
        }

        function deactivateHotspot(hotspot) {
            if (!hotspot) return;
            const inner = hotspot.querySelector('.hs_inner');
            const outer = hotspot.querySelector('.hs_outer');

            popover.style.display = 'none';
            inner.setAttribute('r', '8');
            outer.setAttribute('fill-opacity', '0.25');
        }
    });

}

module.exports = {
    init: init
};